var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6096_18346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7 7.68C20.24 6.68 19.48 6.03 17.95 4.72L16.55 3.52C13.81 1.18 12.44 0 10.58 0C8.72 0 7.35 1.18 4.6 3.53L3.21 4.72C1.69 6.02 0.93 6.68 0.46 7.68C0 8.68 0 9.69 0 11.7V17.59C0 20.44 0 21.87 1.07 22.94C2.14 24.01 3.57 24.01 6.42 24.01H14.75C17.6 24.01 19.03 24.01 20.1 22.94C21.17 21.87 21.17 20.44 21.17 17.59V11.7C21.17 9.69 21.17 8.68 20.71 7.68H20.7ZM7.97 16.2C7.97 15.91 8.21 15.68 8.49 15.68H12.65C12.94 15.68 13.17 15.92 13.17 16.2V22.28H7.96V16.2H7.97ZM12.66 13.95H8.5C7.26 13.95 6.25 14.96 6.25 16.2V22.28C3.99 22.28 2.84 22.27 2.29 21.72C1.73 21.16 1.73 19.97 1.73 17.59V11.7C1.73 9.94 1.73 9.06 2.03 8.41C2.33 7.75 3 7.18 4.34 6.04L5.73 4.85C8.15 2.78 9.36 1.73 10.59 1.73C11.82 1.73 13.03 2.77 15.45 4.85L16.84 6.04C18.17 7.18 18.84 7.75 19.14 8.41C19.44 9.07 19.44 9.95 19.44 11.7V17.59C19.44 19.97 19.44 21.16 18.88 21.72C18.32 22.28 17.18 22.28 14.92 22.28V16.2C14.92 14.96 13.91 13.95 12.67 13.95H12.66Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6096_18346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.f9eff7cfc9d4b30f90dfff02dc02f668.svg";
export { ForwardRef as ReactComponent };